import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';

import InfoCircleIcon from '../../icons/InfoCircleIcon';

const propTypes = {
  id: PropTypes.string.isRequired,
  tip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
  tipProps: PropTypes.object,
  infoCircleProps: PropTypes.object,
};

const InfoCircleTip = ({
  id,
  tip,
  className,
  tipProps = {},
  infoCircleProps = {},
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <span
      className={classes}
      data-for={id}
      data-effect="solid"
      data-place="top"
      data-tip=""
      {...tipProps}
    >
      <InfoCircleIcon color="#0d84fe" size={16} {...infoCircleProps} />
      <ReactTooltip id={id}>{tip}</ReactTooltip>
    </span>
  );
};

InfoCircleTip.propTypes = propTypes;

export default InfoCircleTip;
